export default __webpack_public_path__ + "static/media/johnsonHeadshot.90bb241e.webp";